var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"slider-wrapper"},[_c(_setup.swiper,{staticClass:"swiper",attrs:{"options":_setup.swiperOptions}},_vm._l((_vm.swiperItems),function(item){return _c(_setup.swiperSlide,{key:item.id},[_vm._t("slide-slot",null,{"item":item})],2)}),1),_vm._t("slide-nav")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }